import createModule from "../createModule"
import { getIsOpPro } from "modules/account-root/selectors"
import { getAlphaTheoryConnected, getAlphaTheoryFunds, getImporting, getResourceLimits } from "./selectors"
import { Creators } from "./model"
import view from "./view"
import withOutletContext from "hocs/withOutletContext"

export default withOutletContext(createModule({
  view,
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [{
    resource: "alphaTheoryMetadata",
    url: ({ account }) => {
      if (!account) {
        return null
      }
      return ({
        id: `alphaTheoryMetadata-${account}`,
        url: `/api/${account}/partners/meta?partnerType=alpha_theory`,
      })
    },
  }],
  mapStateToProps: (state, props) => ({
    connected: getAlphaTheoryConnected(state, props),
    funds: getAlphaTheoryFunds(state, props),
    importing: getImporting(state, props),
    resourceLimits: getResourceLimits(state, props),
    isOpPro: getIsOpPro(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
